<script setup lang="ts">
  import type { Address } from '@logistiek-zonder-papier/lzp-library'
  import { FormInput } from '@logistiek-zonder-papier/lzp-library'

  type AddressFields = Pick<
    Address,
    'street' | 'street2' | 'houseNumber' | 'suffix' | 'postalCode' | 'city' | 'country'
  >

  const address = defineModel<AddressFields>({ required: true })
  defineProps<{ errors?: Record<string, string> }>()
</script>

<template>
  <div class="address-row">
    <FormInput
      label="Street"
      v-model="address.street"
      :error="errors ? errors['street'] : undefined"
    />
    <FormInput
      label="Street 2"
      v-model="address.street2"
      :error="errors ? errors['street2'] : undefined"
    />
  </div>

  <div class="address-row">
    <FormInput
      label="Postal Code"
      class="wide"
      v-model="address.postalCode"
      :error="errors ? errors['postalCode'] : undefined"
    />
    <FormInput
      label="Housenumber"
      v-model="address.houseNumber"
      :error="errors ? errors['houseNumber'] : undefined"
    />
    <FormInput
      label="Suffix"
      v-model="address.suffix"
      :error="errors ? errors['suffix'] : undefined"
    />
  </div>

  <div class="address-row">
    <FormInput label="City" v-model="address.city" :error="errors ? errors['city'] : undefined" />
    <FormInput
      label="Country"
      v-model="address.country"
      :error="errors ? errors['country'] : undefined"
      :max-length="3"
    />
  </div>
</template>

<style scoped lang="css">
  .address-row {
    width: 100%;
    display: flex;
    gap: var(--spacing-s);
  }

  .address-row > * {
    flex: 1;
  }

  .address-row > .wide {
    flex: 2;
  }
</style>
